/* tslint:disable */
/* eslint-disable */
export enum UserRegistrationCreditRequestBehavior {
  AutoApproveNoReference = 'auto_approve_no_reference',
  AutoApproveRequireReference = 'auto_approve_require_reference',
  ManualApproveRequireReference = 'manual_approve_require_reference'
}
